import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Analisis/calcularDiasDescanso`, method: 'POST', body: null, token: token})
}